import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { AlgoanLogo } from '@algoan/deep-dive/icons/algoan-logo';
import { ComponentProps } from '@algoan/deep-dive/model';
import { Footer } from '@algoan/deep-dive/footer';
import { Illustration } from './illustration';

export interface ErrorProps extends ComponentProps {
  /** Actions on the bottom of the page */
  buttons?: ReactNode;
  /** Just under the title */
  subTitle?: ReactNode;
  /** Big text on top */
  title?: ReactNode;
}

export const Error: React.FC<ErrorProps> = ({ 'data-testid': dataTestId, buttons, className, subTitle, title }) => {
  return (
    <ErrorStyles.Container className={className} data-testid={dataTestId}>
      <ErrorStyles.AlgoanLogo />
      <ErrorStyles.ContentContainer>
        <ErrorStyles.ImageContainer>
          <Illustration />
        </ErrorStyles.ImageContainer>
        <ErrorStyles.RightContainer>
          <ErrorStyles.TextContainer>
            <ErrorStyles.Title>{title}</ErrorStyles.Title>
            {subTitle && <ErrorStyles.SubTitle>{subTitle}</ErrorStyles.SubTitle>}
          </ErrorStyles.TextContainer>
          {buttons && <ErrorStyles.ButtonContainer>{buttons}</ErrorStyles.ButtonContainer>}
        </ErrorStyles.RightContainer>
      </ErrorStyles.ContentContainer>
      <Footer />
    </ErrorStyles.Container>
  );
};

export const ErrorStyles = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
  ImageContainer: styled.div`
    margin: auto;
    width: 700px;

    @media (max-width: ${({ theme }) => theme.breakpoints.laptopSmall}) {
      display: none;
    }
  `,
  ContentContainer: styled.div`
    display: flex;
    min-height: 100vh;
    padding: 0px 100px 0px 100px;
    gap: 64px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileLarge}) {
      gap: 0px;
      padding: 0px 20px;
    }
  `,
  RightContainer: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: auto;
  `,
  Title: styled.div`
    display: inline;
    white-space: pre-wrap;
  `,
  SubTitle: styled.div`
    display: inline-block;
    margin-top: 16px;
    white-space: pre-wrap;
  `,
  TextContainer: styled.div`
    width: 425px;
    margin-bottom: 48px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileLarge}) {
      width: 100%;
    }
  `,
  ButtonContainer: styled.div``,
  AlgoanLogo: styled(AlgoanLogo)`
    height: 40px;
    width: 121px;
    top: 60px;
    left: 58px;
    position: absolute;
  `,
};
